import React, { useContext } from 'react';
import { parseISO, format } from 'date-fns';
import { LocaleContext, Tooltip } from '@eas/common-web';
import Typography from '@material-ui/core/Typography';
import { LocalDateHistoryField as LocalDateHistoryFieldProps } from '../../../../models';
import { useStyles } from './history-field-styles';
import { HistoryFieldProps } from '../history-types';
import { useHistoryFieldTooltip } from './history-field-tooltip-hook';

export function LocalDateHistoryField({
  valueAfter,
  valueBefore,
}: HistoryFieldProps<LocalDateHistoryFieldProps>) {
  const classes = useStyles();

  const { locale } = useContext(LocaleContext);

  const parsedBefore = valueBefore?.value
    ? format(parseISO(valueBefore.value), locale.dateFormat)
    : undefined;

  const parsedAfter = valueAfter?.value
    ? format(parseISO(valueAfter.value), locale.dateFormat)
    : undefined;

  const {
    ref: afterRef,
    useTooltip: useAfterTooltip,
  } = useHistoryFieldTooltip();

  const {
    ref: beforeRef,
    useTooltip: useBeforeTooltip,
  } = useHistoryFieldTooltip();

  const beforeContent = (
    <span className={classes.textDeleted} ref={beforeRef}>
      - {parsedBefore}
    </span>
  );

  const afterContent = (
    <span className={classes.textAdded} ref={afterRef}>
      + {parsedAfter}
    </span>
  );
  return (
    <Typography variant="body1" className={classes.content}>
      {parsedBefore &&
        (useBeforeTooltip ? (
          <Tooltip title={parsedBefore} placement="top-start" type="HOVER">
            - {beforeContent}
          </Tooltip>
        ) : (
          beforeContent
        ))}
      {parsedAfter &&
        (useAfterTooltip ? (
          <Tooltip title={parsedAfter} placement="top-start" type="HOVER">
            + {afterContent}
          </Tooltip>
        ) : (
          afterContent
        ))}
    </Typography>
  );
}
